export const RACES = {
  "5K": { minWeeks: 6, maxWeeks: 10, taper: 1, longCap: 8, peak: { new: 15, returning: 18, regular: 22, competitive: 30 }, key: { base: "Strides + hill sprints", build: "Intervals: 12x400m → 5x1000m at race pace", peak: "3x1K at goal pace, full rest", taper: "4x200m relaxed fast" }, category: "5K" },
  "10K": { minWeeks: 8, maxWeeks: 12, taper: 1, longCap: 10, peak: { new: 20, returning: 24, regular: 28, competitive: 35 }, key: { base: "Strides + hills", build: "Alternate: 5x1000m @ 5K effort / 3x2K @ threshold", peak: "3x2mi at goal 10K pace", taper: "4x400m at pace" }, category: "10K" },
  "Half Marathon": { minWeeks: 10, maxWeeks: 14, taper: 2, longCap: 13, peak: { new: 22, returning: 26, regular: 32, competitive: 40 }, key: { base: "Strides + hills", build: "Threshold: 3x1mi → 4-5mi tempo", peak: "12mi long run, last 4 at goal pace", taper: "2mi at race pace mid-week" }, category: "Half Marathon" },
  "Marathon": { minWeeks: 14, maxWeeks: 18, taper: 3, longCap: 20, peak: { new: 35, returning: 40, regular: 45, competitive: 55 }, key: { base: "Easy volume + strides", build: "MP blocks in long runs + weekly threshold", peak: "18-20mi with 8-10 at marathon pace", taper: "Short MP touches only" }, category: "Marathon" },
  "Ultra 50K": { minWeeks: 16, maxWeeks: 20, taper: 2, longCap: 22, peak: { new: 40, returning: 44, regular: 50, competitive: 60 }, key: { base: "Trail time + hiking practice", build: "Back-to-back weekends, fueling practice", peak: "20mi + 10mi race-sim weekend", taper: "Easy trail miles" }, category: "Ultra" },
  "HYROX": { minWeeks: 8, maxWeeks: 12, taper: 1, longCap: 10, peak: { new: 20, returning: 22, regular: 26, competitive: 32 }, key: { base: "Easy runs + sled technique, 2x strength", build: "Compromised runs: station + 1K repeats", peak: "Half-simulation: 4 stations + 4 runs", taper: "Mobility + short race-pace touches" }, category: "HYROX" },
  "Ironman Run": { minWeeks: 12, maxWeeks: 18, taper: 2, longCap: 16, peak: { new: 22, returning: 25, regular: 28, competitive: 35 }, key: { base: "Easy runs + short bricks off the bike", build: "Weekly brick growing 20→60min + long run", peak: "2.5hr long run + 60min race-effort brick", taper: "Short bricks, race fueling rehearsal" }, category: "Ironman" },
};

export const LEVELS = {
  new: { label: "NEW TO TRAINING", start: 0.4 },
  returning: { label: "RETURNING AFTER A BREAK", start: 0.5 },
  regular: { label: "TRAIN REGULARLY", start: 0.6 },
  competitive: { label: "COMPETITIVE / CHASING A PR", start: 0.7 },
};

export function buildPlan({ race, level, currentMiles, days, weeks }) {
  const cfg = RACES[race];
  const total = Math.min(Math.max(weeks, cfg.minWeeks), cfg.maxWeeks);
  const peakMiles = cfg.peak[level];
  const start = Math.max(Math.min(currentMiles || peakMiles * LEVELS[level].start, peakMiles * 0.85), peakMiles * 0.35);
  const taperWeeks = cfg.taper;
  const peakWeeks = 2;
  const rampWeeks = total - taperWeeks - peakWeeks;
  const baseWeeks = Math.max(2, Math.round(rampWeeks * 0.4));

  const plan = [];
  for (let w = 1; w <= total; w++) {
    let phase, miles;
    if (w <= rampWeeks) {
      phase = w <= baseWeeks ? "base" : "build";
      const f = rampWeeks === 1 ? 1 : (w - 1) / (rampWeeks - 1);
      miles = start + (peakMiles - start) * f;
      if (w % 4 === 0 && w < rampWeeks) miles *= 0.75;
    } else if (w <= rampWeeks + peakWeeks) {
      phase = "peak";
      miles = peakMiles;
    } else {
      phase = "taper";
      const t = w - rampWeeks - peakWeeks;
      miles = peakMiles * (taperWeeks === 3 ? [0.8, 0.6, 0.4][t - 1] : taperWeeks === 2 ? [0.7, 0.45][t - 1] : 0.55);
    }
    const longRun = Math.min(Math.round(miles * 0.34 * 2) / 2, cfg.longCap);
    const isCutback = w % 4 === 0 && w < rampWeeks;
    plan.push({
      week: w,
      phase,
      miles: Math.round(miles),
      long_run: phase === "taper" && w === total ? Math.min(longRun, 8) : longRun,
      key: isCutback ? "Cutback week: easy miles + strides only" : cfg.key[phase],
    });
  }
  return { race, level, days, total, peakMiles, plan, category: cfg.category };
}
